// EDITABLE OFFER + STORE SETTINGS
// Values in [BRACKETS] are placeholders — replace them with confirmed values before publishing.
export const site = {
  productName: 'Physical Education Ready',
  shortName: 'PE Ready',
  checkoutUrl: '#offer', // replace with the Impultienda checkout URL
  supportEmail: '[SUPPORT EMAIL]',
  year: '[YEAR]',
  regularPrice: '[REGULAR PRICE]',
  discount: '[DISCOUNT]',
  currentPrice: '[CURRENT PRICE]',
  guaranteeDays: '[NUMBER]',
  // Set to false to hide the testimonial section cleanly until verified reviews exist.
  showTestimonials: true,
  legalLinks: [
    { label: 'Terms and Conditions', href: '#terms' },
    { label: 'Privacy Policy', href: '#privacy' },
    { label: 'Refund Policy', href: '#refunds' },
    { label: 'License Terms', href: '#license' },
    { label: 'Contact', href: '#contact' },
  ],
  heroImage: 'https://cdn.magicpatterns.com/uploads/hGCcHJuovxF8Vea4Gzpq4u/WhatsApp_Image_2026-08-06_at_16.23.38-Photoroom.png',
  heroImageAlt:
    'Physical Education Ready system: five Elementary volumes, five Secondary volumes, digital lesson materials on desktop, tablet and phone, five bonus workbooks, and PE equipment',
}

export const CTA_LABEL = 'GET PHYSICAL EDUCATION READY'
export const CTA_MICROCOPY = 'Instant digital access • One-time payment • Lifetime access'
